import keys from 'lodash/keys';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import omit from 'lodash/omit';
import up from 'updeep';
import localStorageHelper from '../../lib/localStorageHelper';

const localStorageKey = 'redux';

const load = (preconfiguredState) => {
  if (!localStorageHelper.isAccessible()) return preconfiguredState;
  let stored = {};
  try {
    stored = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    if (isEmpty(stored)) {
      // pull inputs from legacy localStorage.
      const userFootprint = JSON.parse(localStorage.getItem('user_footprint') || '{}');
      stored.user_footprint = {
        inputs: pickBy(userFootprint, (_value, key) => /^input_/.test(key)),
      };
    }
  } catch (err) {
    stored = {};
  }

  if (stored.leaders) delete stored.leaders;
  if (stored.seed) delete stored.seed;

  return keys(preconfiguredState)
    .reduce((state, key) => ({
      ...state,
      [key]: up(get(stored, key, {}), get(preconfiguredState, key, {})),
    }), {});
};

let timeout;
const debounceTime = 3000;

const prepareStateForSave = (state) => {
  const data = omit(state, ['location', 'leaders', 'search', 'locationAutocomplete', 'accountForm']);
  data.ui = {
    ...omit(data.ui, ['agreedToTermsAndConditions']),
    widget: null,
    modal: '',
    modalLeader: null,
    errors: {},
    spinner: false,
  };
  data.auth = {
    ...data.auth,
    password: '',
    locationSuggestions: [],
    passwordConfirm: '',
  };
  data.accountForm = {
    ...data.accountForm,
    profilePhotoPreview: '',
  };
  return data;
};

const save = store => next => (action) => {
  if (!localStorageHelper.isAccessible()) return next(action);
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    const state = store.getState();
    const data = prepareStateForSave(state);

    localStorage.setItem(localStorageKey, JSON.stringify(data));
    timeout = undefined;
  }, debounceTime);
  return next(action);
};

export default {
  save,
  load,
};
